import { useAuthStore } from '@/store/auth-store'
import { hasPermission, Permissions } from './index'

export const useCheckPermissions = (): (<Resource extends keyof Permissions>(
    resource: Resource,
    action: Permissions[Resource]['action'],
    data?: Permissions[Resource]['dataType']
) => boolean) => {
    const { role } = useAuthStore()
    return (...args) => hasPermission(role, ...args)
}
